import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import MainLayout from "../../../components/layout/MainLayout";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import BDIForm from "./BDIForm";
import { BDIFormQuestions } from "./BDIForm";

// Import the thunk from your slice
import { createBdiAssessment } from "../../../store/slices/bdiAssessmentsSlice";
import { fetchPatient } from "../../../store/slices/patientsSlice"; // Added this import

const AddBDI = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const { caseId, patientId } = state || {};


    const [formData, setFormData] = useState({
        patientId, // initialize
        caseId,    // initialize
        clientName: "",
        diagnosis: "",
        assessedBy: "",
        q1: "", q2: "", q3: "", q4: "", q5: "", q6: "", q7: "", q8: "", q9: "", q10: "",
        q11: "", q12: "", q13: "", q14: "", q15: "", q16: "", q17: "", q18: "", q19: "", q20: "", q21: ""
    });

    useEffect(() => {
        if (patientId) {
            dispatch(fetchPatient(patientId))
                .unwrap()
                .then((patient) => {
                    if (patient) {
                        setFormData((prev) => ({
                            ...prev,
                            clientName: `${patient.first_name || ""} ${patient.last_name || ""}`.trim(),
                        }));
                    }
                })
                .catch((err) => console.error("Failed to fetch patient for BDI:", err));
        }
    }, [dispatch, patientId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const calculateTotal = () => {
        let sum = 0;
        for (let i = 1; i <= 21; i++) {
            sum += parseInt(formData[`q${i}`] || "0", 10);
        }
        return sum;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Map questions to their names for backend
        const questionNames = [
            "sadness",
            "pessimism",
            "past_failure",
            "loss_of_pleasure",
            "guilty_feelings",
            "punishment_feelings",
            "self_dislike",
            "self_criticalness",
            "suicidal_thoughts",
            "crying",
            "agitation",
            "loss_of_interest",
            "indecisiveness",
            "worthlessness",
            "loss_of_energy",
            "changes_in_sleeping",
            "irritability",
            "changes_in_appetite",
            "concentration_difficulty",
            "tiredness_fatigue",
            "loss_of_interest_in_sex"
        ];

        // Build question scores/values for backend
        const questionPayload = {};
        questionNames.forEach((name, index) => {
            const qKey = `q${index + 1}`;
            const score = parseInt(formData[qKey] || 0, 10);

            // Get the option text as value
            const optionText = BDIFormQuestions[index].options[score] || "";

            questionPayload[`${name}_score`] = score;
            questionPayload[`${name}_value`] = optionText;
        });

        const payload = {
            patient_id: formData.patientId || null,
            case_id: formData.caseId || null,
            client_name: formData.clientName || "",
            diagnosis: formData.diagnosis || "",
            assessed_by: formData.assessedBy || "",
            ...questionPayload
        };

        // Optional: total_score field
        const total_score = Object.keys(questionPayload)
            .filter(k => k.endsWith("_score"))
            .reduce((sum, k) => sum + questionPayload[k], 0);

        payload.total_score = total_score;

        if (total_score === 0) {
            Swal.fire("Incomplete", "Please complete all 21 items.", "warning");
            return;
        }

        try {
            await dispatch(createBdiAssessment(payload)).unwrap();
            Swal.fire({
                title: "Saved!",
                text: `BDI-II Assessment completed. Total Score: ${total_score}`,
                icon: "success",
                timer: 2000,
                showConfirmButton: false
            });
            navigate(`/cases/${caseId}/profile`, { state: { patientId, caseId } });
        } catch (error) {
            Swal.fire("Error", error || "Failed to save BDI-II assessment.", "error");
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <BDIForm formData={formData} handleChange={handleChange} />
                            <div className="col-12 d-flex justify-content-end mt-3">
                                <div className="col-md-2 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary">
                                        <i className="ri-save-2-line me-1"></i> Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddBDI;
